import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import "./AppHeader.scss";

// cora web components
import ComponentTitle from "../../components/ComponentTitle";

class AppHeader extends React.Component {
  render() {
    const { header } = this.props;

    return (
      <>
        {header.show &&
          <div className="row m-0">
            <div className="col p-0">
              <div className="appHeader">
                <ComponentTitle text={header.title} />
                <div className="row m-0"></div>
              </div>
            </div>
          </div>
        }
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    header: state.header.data,
  };
};

const mapDispatchToProps = (dispatch) => ({});

AppHeader.propTypes = {
  header: PropTypes.shape({
    data: PropTypes.shape({
      show: PropTypes.bool,
      title: PropTypes.string,
    }),
  }),
};

export default connect(mapStateToProps, mapDispatchToProps)(AppHeader);
